export default __webpack_public_path__ + "static/media/BisleyCat2021-400x482.389a6838.jpg";